import React from 'react';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface TermsProps {
  language: Language;
}
export function Terms({
  language
}: TermsProps) {
  const isPashto = language === 'pashto';
  const sections = isPashto ? [{
    title: 'د منلو شرایط',
    text: 'د دې ویبپاڼې په کارولو سره تاسو دا شرایط او ضوابط منئ. که تاسو موافق نه یاست، مهرباني وکړئ ویبپاڼه مه کاروئ.'
  }, {
    title: 'د منځپانګې ملکیت',
    text: 'ټوله منځپانګه چې په دې ویبپاڼه کې خپره شوې، پشمول مقالې، شعرونه او انځورونه، د اړوندو لیکوالانو او پاڅون خپرندویه ادارې ملکیت ده. د اجازې پرته کاپي کول منع دي.'
  }, {
    title: 'د کارونکي مسؤلیتونه',
    text: 'تاسو موافقه کوئ چې دا ویبپاڼه یوازې قانوني موخو لپاره وکاروئ. تاسو به هیڅ منځپانګه نه خپروئ چې غلط، توهین آمیز یا غیرقانوني وي.'
  }, {
    title: 'ګډون',
    text: 'د ګډون تادیات د PayPal له لارې ترسره کیږي. ټول تادیات غیر قابل بیرته ستنیدو دي مګر دا چې بل ډول ویل شوي وي.'
  }, {
    title: 'د مسؤلیت محدودیت',
    text: 'پاڅون مجله د ویبپاڼې کارولو څخه رامنځته شوي هیڅ مستقیم یا غیر مستقیم زیان لپاره مسؤل نه ده.'
  }, {
    title: 'تعدیلات',
    text: 'موږ حق لرو چې دا شرایط هر وخت تعدیل کړو. دوامداره کارول د تعدیل شویو شرایطو منل ګڼل کیږي.'
  }] : [{
    title: 'Acceptance of Terms',
    text: 'By using this website, you agree to these terms and conditions. If you do not agree, please do not use the website.'
  }, {
    title: 'Content Ownership',
    text: 'All content published on this website, including articles, poems, and images, is the property of the respective authors and Pasoon Publishers. Copying without permission is prohibited.'
  }, {
    title: 'User Responsibilities',
    text: 'You agree to use this website only for lawful purposes. You shall not post any content that is false, defamatory, or illegal.'
  }, {
    title: 'Subscriptions',
    text: 'Subscription payments are processed through PayPal. All payments are non-refundable unless otherwise stated.'
  }, {
    title: 'Limitation of Liability',
    text: 'Pasoon magazine is not liable for any direct or indirect damages arising from the use of this website.'
  }, {
    title: 'Modifications',
    text: 'We reserve the right to modify these terms at any time. Continued use constitutes acceptance of the modified terms.'
  }];
  return <div className="pt-24 md:pt-28" data-id="element-732">
      <PageHero language={language} titleEn="Terms & Conditions" titlePs="شرایط او ضوابط" introEn="Please read these terms carefully before using our website and services." introPs="مهرباني وکړئ د زموږ ویبپاڼې او خدماتو کارولو دمخه دا شرایط په دقت سره ولولئ." data-id="element-733" />

      <section className="py-20 bg-white px-6" data-id="element-734">
        <div className="max-w-3xl mx-auto space-y-10" data-id="element-735">
          {sections.map((section, idx) => <div key={idx} className="border-b border-gray-100 pb-8 last:border-0" data-id="element-736">
              <h3 className={`text-xl font-bold text-pasoon-dark mb-3 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-737">
                {section.title}
              </h3>
              <p className={`text-gray-600 ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-738">
                {section.text}
              </p>
            </div>)}
        </div>
      </section>
    </div>;
}